.root {
  display: grid;
  gap: 40px;
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    gap: 30px;
  }
}

@media screen and (width >= 1024px) {
  .screen {
    gap: 30px;
  }
}
